import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'e1p.gateway.views.dashboard.title',
        defaultMessage: 'Dashboard'
    },
    openQuotesTile: {
        id: 'e1p.gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Quotes',
        defaultMessage: 'Open Quotes'
    },
    policyChangeTile: {
        id: 'e1p.gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Policy Changes',
        defaultMessage: 'Open Policy Changes'
    },
    cancellationsTile: {
        id: 'e1p.gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Policy Cancellation',
        defaultMessage: 'Open Policy Cancellation'
    },
    openRenewalsTile: {
        id: 'e1p.gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Renewals',
        defaultMessage: 'Open Renewals'
    },
    upComingActivities: {
        id: 'e1p.gateway.views.activities.Activities for the next 7 days',
        defaultMessage: 'Your Open Activities for the next 7 days'
    }
});
